var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mt-3"},[_c('v-alert',{attrs:{"colored-border":"","border":"left","elevation":"2","color":_vm.color,"icon":_vm.icon}},[[_vm._t("content")]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }